import React from 'react';
import { NewsContactScreen } from "../../components/news/NewsContactScreen"

const PRESS_EMAIL = 'press@cohostop.com';

export const NewsContactContainer = () => {
    return <NewsContactScreen email={PRESS_EMAIL} />
}